import type { AutoGeneratorForFormModel } from "@/components/features/_model";

import type { SetupInputZodSchemaType } from "./validation-schema";

const _excludeKeys = [""] as const;
export const excludeKeys = _excludeKeys.map((key) => key);
export type ExcludeKeys = (typeof excludeKeys)[number];

export type SetupFormModel = AutoGeneratorForFormModel<SetupInputZodSchemaType, ExcludeKeys, undefined>;
